module.exports = __webpack_public_path__ + "static/media/Data_report_amico.9c0ec2bd.svg";